import { AxiosRequestConfig } from 'axios'

import { ParametersDownload } from './types'

const getStores = ({ startDate, endDate, storeIds }: ParametersDownload): AxiosRequestConfig => {
  const params = {
    ...(startDate ? { startDate: startDate.format('YYYY-MM-DD') } : {}),
    ...(endDate ? { endDate: endDate.format('YYYY-MM-DD') } : {}),
    ...(storeIds ? { storeIds } : {}),
  }

  return {
    url: 'dashboard/stores',
    method: 'GET',
    params,
  }
}

export { getStores }
